/** @format */

import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { of, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { CommuteService } from "../../../services/commute.service";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { ConfigurationService } from "../../../services/configuration.service";

export interface ICommuteChoice {
  id: number;
  name: string;
  icon: string;
  activeIcon: string;
}
@Component({
  selector: "[mis-employee-web-exp-commute]",
  templateUrl: "./commute.component.html",
  styleUrls: ["./commute.component.scss"]
})
export class CommuteComponent implements OnInit, OnDestroy {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  private endObs = new Subject<void>();
  reachingOptions: NsEmpWebExpData.ICommuteOption[] = [];
  leavingOptions: NsEmpWebExpData.ICommuteOption[] = [];
  reachingSelection: NsEmpWebExpData.ICommuteOption;
  leavingSelection: NsEmpWebExpData.ICommuteOption;
  private initComplete = false;
  @Input() config: NsWISConfigurations.IConfigurations;
  commuteChoices: ICommuteChoice[] = [];

  constructor(public commuteSvc: CommuteService, private configSvc: ConfigurationService) {}

  ngOnInit(): void {
    this.commuteSvc.formData.pipe(takeUntil(this.endObs)).subscribe(res => {
      const commute = res?.[2];
      [this.reachingOptions, this.leavingOptions] = res;
      this.reachingSelection =
        commute?.login ||
        (this.initComplete && this.reachingSelection) ||
        (this.config.flattenedSettings.enableTransportByDefault && this.reachingOptions.find(item => !item.disable && item.id === "transport"));
      this.leavingSelection =
        commute?.logout ||
        (this.initComplete && this.leavingSelection) ||
        (this.config.flattenedSettings.enableTransportByDefault && this.leavingOptions.find(item => !item.disable && item.id === "transport"));
      this.reachingSelection = this.reachingOptions.find(
        opt => !opt.disable && opt.id === this.reachingSelection?.id && opt.name === this.reachingSelection?.name
      );
      this.leavingSelection = this.leavingOptions.find(
        opt => !opt.disable && opt.id === this.leavingSelection?.id && opt.name === this.leavingSelection?.name
      );
      this.initComplete = true;
      if (commute?.login?.id === "parking") {
        this.setChoice(this.commuteChoices.find(c => c.id === 1));
      }
      this.commuteSvc.setCommute([this.reachingSelection, this.leavingSelection]);
    });
    this.config.flattenedSettings.showCabs &&
      this.commuteChoices.push({
        id: 0,
        name: "OFFICE CAB",
        icon: this.Assets.ICONS.TRANSPORT,
        activeIcon: this.Assets.ICONS.TRANSPORT_ACTIVE
      });
    this.config.flattenedSettings.showParking &&
      this.commuteChoices.push({ id: 1, name: "PARKING", icon: this.Assets.ICONS.PARKING, activeIcon: this.Assets.ICONS.PARKING_ACTIVE });
    this.setChoice(this.commuteChoices[0]);
  }

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }

  setCommuteSelection(type: 0 | 1, value: NsEmpWebExpData.ICommuteOption): void {
    if (type === 0) {
      this.reachingSelection = value;
      if (value.id !== "transport" && this.leavingSelection?.id === "transport") {
        this.leavingSelection = this.leavingOptions[this.leavingOptions.length - 1];
      }
    } else {
      this.leavingSelection = value;
    }
    if (this.configSvc.isMobile) {
      this.commuteSvc.temporaryCommuteSelection = [this.reachingSelection, this.leavingSelection];
      return;
    }
    this.commuteSvc.setCommute([this.reachingSelection, this.leavingSelection]);
  }

  setChoice(opt: ICommuteChoice): void {
    this.commuteSvc.currentChoice = opt;
  }
}
